import React, { useState, useEffect, useRef } from 'react'
import { Typography, withStyles, Popover } from '@material-ui/core'
import { CoreTextField } from 'src/components/core'
import { useSelector, useDispatch } from 'react-redux'
import URL from 'src/api/url/api'
import styles from './styles'
import { mediaImageUploadAction } from 'src/reducers/media-image/action'

import FontPicker from 'font-picker-react'
import { ChromePicker } from 'react-color'
import {
  messageBoxHideAction,
  messageBoxShowAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import ContainerMediaGalery from 'src/container/image-gallery'
import { track } from '@amplitude/analytics-browser'
import { PatchContent, PatchData } from 'src/model/patch'
import { CoreIconButton } from 'src/components/core'
import { Icon } from '@iconify/react'
// Helper function to get the correct image URL
const getImageUrl = url => {
  if (!url) return ''
  // Check if the URL already contains https, don't add URL.MEDIA in that case
  return url.includes('https') ? url : `${URL.MEDIA}${url}`
}

const EditCard = props => {
  const {
    classes,
    onSave,
    thumbnailUrl,
    description: initialDescription,
    setImageURL,
  } = props
  const dispatch = useDispatch()

  const [thumbnail, setThumbnail] = useState(null)
  const [description, setDescription] = useState('')

  useEffect(() => {
    setThumbnail(thumbnailUrl || null)
    setDescription(initialDescription || '')
  }, [thumbnailUrl, initialDescription])

  useEffect(() => {
    updateSetting('thumbnail', thumbnail)
    updateSetting('description', description)

    if (thumbnail && typeof setImageURL === 'function') {
      setImageURL(thumbnail)
    }
  }, [thumbnail, description])

  const updateSetting = (key, value) => {
    const updatedSettings = {
      thumbnail: thumbnail,
      description: description,
    }
    onSave(updatedSettings)
  }

  const handleThumbnailGalleryOpen = () => {
    track('thumbnail_media_gallery_clicked')

    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: `
            <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
              <Icon icon="ic:round-add-a-photo" color="#00AB55" width="24" height="24" />
              <Typography style="margin-left: 8; color: #002E47; fontWeight: 600; fontSize: 16;">
                Media Gallery - Thumbnail
              </Typography>
            </div>
          `,
          component: (
            <ContainerMediaGalery
              onOk={items => {
                const newUrl = items[0].url
                setThumbnail(newUrl)
                updateSetting('thumbnail', newUrl)

                if (typeof setImageURL === 'function') {
                  setImageURL(newUrl)
                }

                dispatch(messageBoxHideAction('message-box-1'))
              }}
              setImageURL={url => {
                if (url && typeof setImageURL === 'function') {
                  setImageURL(url)
                }
              }}
            />
          ),
          maxHeight: '70vh',
        }),
      ),
    )
  }

  const handleDescriptionChange = e => {
    const newValue = e.target.value
    setDescription(newValue)
    updateSetting('description', newValue)
  }

  return (
    <div className={classes.container}>
      <div className={classes.section}>
        <div>
          <Typography fontSize="14px" fontWeight={500} fontFamily="Inter">
            Thumbnail image
          </Typography>
          <Typography fontSize="12px" fontWeight={400} color="#919EAB">
            Shown in mini course cards and social posts.
          </Typography>
        </div>
        <div className={classes.uploadContainer}>
          {thumbnail ? (
            <div className={classes.imagePreview}>
              <div
                className={classes.thumbnailView}
                style={{
                  background: `url(${getImageUrl(thumbnail)})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              >
                <div className={classes.iconButton}>
                  <CoreIconButton
                    color="white"
                    size="small"
                    onClick={() => {
                      setThumbnail(null)
                      updateSetting('thumbnail', null)

                      if (typeof setImageURL === 'function') {
                        setImageURL(null)
                      }
                    }}
                  >
                    <Icon icon="bx:trash-alt" />
                  </CoreIconButton>
                </div>
              </div>
              <Typography fontSize="12px" fontWeight={400} color="#919EAB">
                Supported formats: JPG, or PNG. Maximum file size: 500KB
                <br />
                Recommended min. size: 284 × 160 px
              </Typography>
            </div>
          ) : (
            <div className={classes.uploadBoxContainer}>
              <div
                className={classes.uploadBox}
                onClick={handleThumbnailGalleryOpen}
              >
                <div className={classes.plusIcon}>+</div>
              </div>
              <Typography fontSize="12px" fontWeight={400} color="#919EAB">
                Supported formats: JPG, or PNG. Maximum file size: 500KB
                <br />
                Recommended min. size: 284 × 160 px
              </Typography>
            </div>
          )}
        </div>
      </div>
      <div className={classes.section}>
        <div>
          <Typography fontSize="14px" fontWeight={500} fontFamily="Inter">
            Card description
          </Typography>
          <Typography fontSize="12px" fontWeight={400} color="#919EAB">
            Appears mini course cards within collections. Recommended: 80
            characters
          </Typography>
        </div>
        <div>
          <CoreTextField
            label=""
            maxRows={3}
            marginTop={false}
            minRows={3}
            fullWidth
            value={description || ''}
            onChange={handleDescriptionChange}
            placeholder="Card description"
            variant="outlined"
            size="medium"
          />
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(EditCard)
